var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClose = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M8.25 6.5l3.455-3.456a1.238 1.238 0 00-1.75-1.75L6.5 4.752 3.044 1.295a1.238 1.238 0 00-1.75 1.75L4.752 6.5 1.295 9.956a1.236 1.236 0 101.749 1.749L6.5 8.25l3.456 3.455a1.231 1.231 0 001.749 0 1.236 1.236 0 000-1.75L8.25 6.5z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.96e0c9b6.svg";
export { ForwardRef as ReactComponent };